export const loadScript = (
  id: string,
  src: string,
  attributes?: Record<string, string>
) => {
  const existing = document.getElementById(id)
  if (existing) {
    existing.remove()
  }

  const script = document.createElement('script')
  script.id = id
  script.async = true
  script.src = src

  if (attributes) {
    Object.entries(attributes).forEach(([key, value]) => {
      script.setAttribute(key, value)
    })
  }

  document.body.appendChild(script)
}

export const removeScript = (id: string) => {
  const existing = document.getElementById(id)
  if (existing) existing.remove()
}

export const deleteCookie = (name: string, path = '/') => {
  const hostname = window.location.hostname
  const parts = hostname.split('.')
  const expires = 'Thu, 01 Jan 1970 00:00:00 GMT'

  document.cookie = `${name}=; expires=${expires}; path=${path};`

  for (let i = 0; i < parts.length; i++) {
    const domain = parts.slice(i).join('.')
    document.cookie = `${name}=; expires=${expires}; path=${path}; domain=${domain};`
    document.cookie = `${name}=; expires=${expires}; path=${path}; domain=.${domain};`
  }
}

export const deleteCookiesByPattern = (patterns: string[]) => {
  const cookies = document.cookie.split(';')

  cookies.forEach((cookie) => {
    const [rawName] = cookie.split('=')
    const name = rawName?.trim()
    if (!name) return

    const isMatch = patterns.some((pattern) =>
      name.toLowerCase().includes(pattern.toLowerCase())
    )

    if (isMatch) {
      deleteCookie(name)
    }
  })
}

export const deleteStorageByPattern = (
  storage: Storage,
  patterns: string[]
) => {
  const keysToRemove: string[] = []

  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i)
    if (!key) continue

    const lowerKey = key.toLowerCase()
    const isMatch = patterns.some((pattern) =>
      lowerKey.includes(pattern.toLowerCase())
    )

    if (isMatch) {
      keysToRemove.push(key)
    }
  }

  keysToRemove.forEach((key) => storage.removeItem(key))
}

export const removeTawkArtifacts = () => {
  const win = window as any

  try {
    if (win.Tawk_API?.hideWidget) win.Tawk_API.hideWidget()
    if (win.Tawk_API?.minimize) win.Tawk_API.minimize()
    // do not call shutdown, it prevents clean same-session re-init
  } catch (error) {
    console.log('Tawk cleanup warning:', error)
  }

  const script = document.getElementById('tawk-script')
  if (script) {
    script.remove()
  }

  document.querySelectorAll('iframe').forEach((iframe) => {
    const src = iframe.getAttribute('src') || ''
    const title = (iframe.getAttribute('title') || '').toLowerCase()
    const id = (iframe.getAttribute('id') || '').toLowerCase()
    const className = (iframe.getAttribute('class') || '').toLowerCase()

    if (
      src.includes('tawk.to') ||
      title.includes('tawk') ||
      id.includes('tawk') ||
      className.includes('tawk')
    ) {
      iframe.remove()
    }
  })

  document.querySelectorAll('[id*="tawk"], [class*="tawk"]').forEach((node) => {
    if (node instanceof HTMLElement) {
      node.remove()
    }
  })

  deleteCookiesByPattern(['tawk', 'twk'])
  removeTawkStorageKeys()

  try {
    delete win.Tawk_API
    delete win.Tawk_LoadStart
  } catch {
    win.Tawk_API = undefined
    win.Tawk_LoadStart = undefined
  }
}

export const removeTawkStorageKeys = () => {
  const matchesTawkKey = (key: string) => {
    const lower = key.toLowerCase()
    return lower.startsWith('twk_') || lower.startsWith('tawk_')
  }

  const localKeys = Object.keys(localStorage)
  localKeys.forEach((key) => {
    if (matchesTawkKey(key)) {
      localStorage.removeItem(key)
    }
  })

  const sessionKeys = Object.keys(sessionStorage)
  sessionKeys.forEach((key) => {
    if (matchesTawkKey(key)) {
      sessionStorage.removeItem(key)
    }
  })
}

export const TAWK_CONSENT_STORAGE_KEY = 'tawk-enabled'

export const saveTawkConsentFlag = () => {
  localStorage.setItem(TAWK_CONSENT_STORAGE_KEY, 'true')
}

export const removeTawkConsentFlag = () => {
  localStorage.removeItem(TAWK_CONSENT_STORAGE_KEY)
}